import React from 'react'
import styles from './CombinedLoginScreen.module.scss'
import OtherProductsTile from './OtherProductsTile';
import LoginTile from './LoginTile';

type Props = {
  loginCtaHandler: (_e: Event) => void,
  loginOneTimeEmailCtaHandler: (_e: Event) => void,
  registrationFormMyRacHandler: (_e: Event) => void,
}

const CombinedLoginScreen = ({ loginCtaHandler, loginOneTimeEmailCtaHandler, registrationFormMyRacHandler }: Props) => (
  <div className={styles.pageContainer}>
    <div className={styles.loginContainer}>
      <LoginTile loginCtaHandler={loginCtaHandler} loginOneTimeEmailCtaHandler={loginOneTimeEmailCtaHandler} registrationFormMyRacHandler={registrationFormMyRacHandler} />
      <OtherProductsTile />
    </div>
  </div>
)

export default CombinedLoginScreen;
